<template>
<div class="cart-block">
    <BasketItem
        v-for="(item, index) in items"
        :key="item.ID"
        :item="item"
        @change="onChangeItem"
        @remove="onRemoveItem"
    />
    <div class="cart-block__item grid-column-2 mobile-column-1">
        <div class="common-flex mobile-column">&nbsp;</div>
        <div class="grid-column-2">
            <span class="cart-item-text">&nbsp;</span>
            <span class="cart-item-text common-flex direction-column">
                <span class="cart-item-label">ИТОГО</span>
                {{ totalSum }}р
            </span>
            <span class="cart-item-text">&nbsp;</span>
            <span class="cart-item-button common-flex direction-column">
                <button class="common-button" onclick="document.location = '/checkout/'">Оформить заказ</button>
            </span>
        </div>
    </div>
</div>
</template>

<script>
import BasketItem from './BasketItem';
import BasketHelper from 'etc/BasketHelper';
import debounce from 'lodash-es/debounce';

export default {
    components: {
        BasketItem,
    },

    props: {
    },

    data() {
        return {
            items: app.pageData.basketItems,
            totalSum: app.pageData.totalSum,
        };
    },

    mounted() {
        this.updateItemDebounced = debounce(this.updateItem, 500);
    },

    methods: {
        onChangeItem(data) {
            console.log(data);
            const item = this.items[data.id];

            if (!item) {
                console.error('Basket item not found', data.id);
                return;
            }

            item.oldQuantity = data.quantity;
            item.quantity = data.quantity;
            item.sumValue = item.price * item.quantity;
            this.updateItemDebounced(data.id);
        },

        async onRemoveItem(data) {
            const item = this.items[data.id];

            if (!item) {
                console.error('Basket item not found', data.id);
                return;
            }

            this.$emit('ajax', true);

            let result = await BasketHelper.remove({
                basketItemId: item.id,
                //signedParams: app.soa.signedParams,
            });

            this.$emit('ajax', false);

            if (result) {
                this.$emit('updateData', result);
                this.updateDataFromAjax(result);
            }
        },

        async updateItem(id) {
            const item = this.items[id];
            this.$emit('ajax', true);

            let result = await BasketHelper.changeQuantity({
                basketItemId: id,
                quantity: item.quantity,
            });

            this.$emit('ajax', false);

            if (result) {
                item.quantity = result.changedItem.quantity;
                this.$emit('updateData', result);
                this.updateDataFromAjax(result);
            } else {
                item.quantity = this.oldQuantity;
                delete this.oldQuantity;
            }
        },

        updateDataFromAjax(response) {
            console.log(response);
            this.items = response.items;
            this.totalSum = response.totalSum;
        },
    },
};
</script>